export const setNavWidth = (sizePx: { expanded: string; collapsed: string }): void => {
  document.body.style.setProperty("--left-nav-width", sizePx.expanded);
  document.body.style.setProperty("--left-nav-hidden-width", sizePx.collapsed);
};
